import pb from "@pb/index.json";
import { browserType } from "@js/utils";
import { ScreenValue } from "@js/screen";

const PBJSONROOT = pb.nested.yunpb.nested;
const PBOPERATIONTYPE = PBJSONROOT.OperationType.values;

export const loginPro = (
  key: string,
  deviceId: string,
  deviceType?: string
) => {
  return {
    op: PBOPERATIONTYPE.OP_AUTH,
    reqDesction: "LoginReq",
    resDesction: "LoginRes",
    funcName: "Login",
    serverName: "chikii.userstatus.UserStatusExtObj",
    data: {
      key: key,
      deviceType: deviceType || PBJSONROOT.DeviceType.values.DEVICE_WEB,
      deviceId: deviceId || "",
    },
  };
};

export const loginoutPro = (key: string) => {
  return {
    op: PBOPERATIONTYPE.OP_AUTH,
    reqDesction: "LogoutReq",
    resDesction: "LogoutRes",
    funcName: "Logout",
    serverName: "chikii.userstatus.UserStatusExtObj",
    data: {
      key: key,
    },
  };
};

export const heartbeatPro = () => {
  return {
    reqDesction: "",
    resDesction: "",
    funcName: "",
    op: PBOPERATIONTYPE.OP_HEARTBEAT,
  };
};

export const ChangeWebRtcReq = (
  type: string,
  fromUid: number,
  toUid: number,
  content: any
) => {
  const value =
    typeof content?.toJSON === "function" ? content.toJSON() : content;

  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "ChangeWebRtcInfoReq",
    resDesction: "ChangeWebRtcInfoRes",
    funcName: "ChangeWebRtcInfo",
    serverName: "chikii.node.NodeExtObj",
    data: {
      msg: {
        fromUid: String(fromUid),
        toUid: String(toUid),
        type: type,
        content: JSON.stringify(value),
      },
    },
  };
};

// 进入游戏
export const CltPlayGameReq = (data: pro.yunpb.ICltPlayGameReq) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "CltPlayGameReq",
    resDesction: "CltPlayGameRes",
    funcName: "PlayGame",
    serverName: "chikii.node.NodeExtObj",
    data,
    showNotification: false,
  };
};

export const ConfirmAlreadyReq = (account_id?: number, game_id?: number) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "ConfirmAlreadyMissStatusReq",
    resDesction: "ConfirmAlreadyMissStatusRes",
    funcName: "ConfirmAlreadyMissStatus",
    serverName: "chikii.node.NodeExtObj",
    data: {
      accountId: account_id,
      gameId: game_id,
    },
  };
};

export const CltExitGameReq = (user_id: number) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "CltExitGameReq",
    resDesction: "CltExitGameRes",
    funcName: "ExitGame",
    serverName: "chikii.node.NodeExtObj",
    data: {
      userId: user_id,
    },
  };
};

export const CltCancelQueReq = (user_id: number) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "CltCancelQueReq",
    resDesction: "CltCancelQueRes",
    funcName: "CancelQue",
    serverName: "chikii.node.NodeExtObj",
    data: {
      userId: user_id,
    },
  };
};

export const CltUseQueueCardReq = (cardType: number) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "UseQueueCardReq",
    resDesction: "UseQueueCardRes",
    funcName: "UseQueueCard",
    serverName: "chikii.node.NodeExtObj",
    data: {
      cardType,
    },
  };
};

export const CltUsePriorityReq = (autoUsePriorityType: number) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "UsePriorityReq",
    resDesction: "UsePriorityRes",
    funcName: "UsePriority",
    serverName: "chikii.node.NodeExtObj",
    data: {
      autoUsePriorityType,
    },
  };
};

export const CltGetQueuePanelReq = () => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "GetQueuePanelReq",
    resDesction: "GetQueuePanelRes",
    funcName: "GetQueuePanel",
    serverName: "chikii.node.NodeExtObj",
    data: {},
  };
};

export const CltGetBagItems = (userId?: number) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "GetBagItemsReq",
    resDesction: "GetBagItemsRes",
    funcName: "GetBagItems",
    serverName: "chikii.assets.AssetsExtObj",
    data: { userId },
  };
};

export const CltGetGameRoomInfoReq = (gameId: number) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "GetGameRoomInfoReq",
    resDesction: "GetGameRoomInfoRsp",
    funcName: "GetGameRoomInfo",
    serverName: "chikii.node.NodeExtObj",
    data: {
      gameId,
    },
  };
};

export const CltChangeQueueReq = () => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "CltChangeQueueReq",
    resDesction: "CltChangeQueueRes",
    funcName: "ChangeQueue",
    serverName: "chikii.node.NodeExtObj",
    data: {},
  };
};

export const CltChangeGameReq = (game_id: number, is_high_level: boolean) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "ChangeGameReq",
    resDesction: "ChangeGameRes",
    funcName: "ChangeGame",
    serverName: "chikii.node.NodeExtObj",
    data: {
      gameId: game_id,
      isHighLevel: is_high_level,
    },
  };
};

export const CltSpecifiedSvrReq = (
  user_id: number,
  server_dbid: number,
  device_id: number
) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "CltCancelQueReq",
    resDesction: "CltCancelQueRes",
    funcName: "CancelQue",
    serverName: "chikii.node.NodeExtObj",
    data: {
      userId: user_id,
      serverDbid: server_dbid,
      deviceId: device_id,
    },
  };
};

export const WebRtcKeyboardReq = (cmd: number) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "WebRtcKeyboardReq",
    resDesction: "WebRtcKeyboardRes",
    funcName: "PushWebRtcKeyboard",
    serverName: "chikii.node.NodeExtObj",
    data: {
      msg: cmd,
    },
  };
};

export const WebRtcJoyStickReq = (data: string) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "WebRtcJoyStickReq",
    resDesction: "WebRtcJoyStickRes",
    funcName: "WebRtcJoyStickReq",
    serverName: "chikii.node.NodeExtObj",
    data: {
      msg: data,
    },
  };
};

export enum EResolutionType {
  MEDIA_QUALITY_AUTO = 0x0, // auto
  MEDIA_QUALITY_BLUE = 0x01, //
  MEDIA_QUALITY_HIGH = 0x02, //
  MEDIA_QUALITY_MIDDLE = 0x03, //
  MEDIA_QUALITY_LOW = 0x04, //
}

export const WebrtcSwitchQualityReq = (type: EResolutionType = 0) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "WebrtcSwitchQualityReq",
    resDesction: "WebrtcSwitchQualityRes",
    serverName: "chikii.node.NodeExtObj",
    data: {
      msg: {
        quality: type,
      },
    },
  };
};

export const RPCInput = (
  obj: string,
  func: string,
  req: ArrayBuffer | null,
  opt: Record<string, unknown> = {}
) => {
  return {
    obj,
    func,
    req,
    opt,
  };
};

export const PlayerTimeReq = (user_id: number) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "PlayerTimeReq",
    resDesction: "PlayerTimeRes",
    funcName: "GetPlayerTime",
    serverName: "chikii.node.NodeExtObj",
    data: {
      userId: user_id,
    },
  };
};

export const PlayerStatus = (user_id: number) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "GetPlayerStatusReq",
    resDesction: "GetPlayerStatusRes",
    funcName: "GetPlayerStatus",
    serverName: "chikii.node.NodeExtObj",
    data: {
      accountId: user_id,
      isNew: true,
    },
  };
};

export const WebrtcPingReq = (ping: number) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "WebrtcPingReq",
    resDesction: "WebrtcPingRes",
    serverName: "chikii.node.NodeExtObj",
    data: {
      msg: {
        ping: ping,
      },
    },
  };
};

export const ClientType = () => {
  console.log("browserType", browserType());
  switch (browserType()) {
    case "Chrome":
      return 6;
    case "Edge":
      return 7;
    case "Firefox":
      return 8;
    case "Opera":
      return 9;
    default:
      return 0;
  }
};

export const LoginMediaServer = (
  codeType: number,
  width?: number,
  height?: number
) => {
  console.log("LoginMediaServer", ScreenValue());
  return {
    ver: 1,
    clitentType: ClientType(),
    codeType: codeType,
    width: width || ScreenValue()?.width,
    height: height || ScreenValue()?.height,
  };
};

export const WebRtcChangeGamesReq = (gameInfo: Record<string, unknown>) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "ChangeGamesReq",
    resDesction: "ChangeGamesRes",
    serverName: "chikii.node.NodeExtObj",
    data: {
      gameInfo: gameInfo,
    },
  };
};

export const CltGetCanUseTime = () => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "GetCanUseTimeReq",
    resDesction: "GetCanUseTimeRes",
    funcName: "GetCanUseTime",
    serverName: "chikii.node.NodeExtObj",
    data: {},
  };
};

export const CltRestartGame = (data: Record<string, unknown>) => {
  return {
    op: PBOPERATIONTYPE.OP_SEND_SMS,
    reqDesction: "RestartGameInServerReq",
    resDesction: "RestartGameInServerRes",
    funcName: "RestartGameInServer",
    serverName: "chikii.node.NodeExtObj",
    data,
  };
};
